import React from 'react';
import { authStore } from './AuthStore';
import { Unauthorized } from '../../components/layout/security/Unauthorized';

const USER_ROLES = Object.freeze({
	ADMIN: 'Admin',
	MANAGER: 'Manager',
	CANDIDATE: 'Candidate',
	RECRUITER: 'Recruiter',
	ACCOUNT_MANAGER: 'Account Manager',
	TALENT_LEADER: 'Talent Leader',
	TECHNICAL_INTERVIEWER: 'Technical Interviewer'
});

const NON_CANDIDATE_USER_ROLES = Object.freeze(
	Object.values(USER_ROLES).filter(role => role !== USER_ROLES.CANDIDATE)
);

const rolesAllowed = roles => WrappedComponent => {
	return class extends React.Component {
		render() {
			if (isUserDisabled()) {
				console.error(
					`Unauthorized access to /${WrappedComponent.displayName}`
				);
				return <Unauthorized />;
			}
			if (isUserInRoles(roles)) {
				return <WrappedComponent roles={roles} {...this.props} />;
			} else {
				console.error(
					`Unauthorized access to /${WrappedComponent.displayName}`
				);
				return <Unauthorized />;
			}
		}
	};
};

function isUserDisabled() {
	return authStore.isUserDisabled();
}

function isUserInRoles(roles) {
	if (!roles.length) {
		return true;
	}
	let authorized = false;
	roles.forEach(role => {
		if (authStore.isUserInRole(role)) {
			authorized = true;
			return;
		}
	});
	return authorized;
}

export { rolesAllowed, USER_ROLES, NON_CANDIDATE_USER_ROLES, isUserInRoles };
